

























































import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import PaymentMethodMixin from './PaymentMethodMixin';
import MonthSelector from '@/Shared/MonthSelector.vue';
import { PaymentSubmission } from '@/Payment/PaymentSubmission';
import { PaymentResult } from '@/Payment/PaymentResult';

const component = mixins(PaymentMethodMixin).extend({
    components: {
        MonthSelector
    },
    mounted() {
        const payButton = this.$refs.payButton as HTMLButtonElement;
        payButton.scrollIntoView();
    },
    computed: {
        submission(): PaymentSubmission<any> {
            // They only enter last two digits
            const expiryYear = this.expiryYear! + 2000;
            // Date constructor wants month index, not number
            const expiryMonth = this.expiryMonth! - 1;
            return {
                toPay: this.recordsToPay,
                customer: this.customer,
                paymentMethod: {
                    creditCardNumber: this.cardNumber,
                    cvv: this.cvv,
                    expirationDate: new Date(expiryYear, expiryMonth),
                    paymentSource: this.source,
                    paymentMethod: this.paymentMethod,
                }
            };
        },
    },
    data() {
        return {
            i18nPrefix: 'payment.cardPayment',
            expiryMonth: null as number | null,
            expiryYear: null as number | null,
            cardNumber: null as string | null,
            cvv: null as string | null,
            paymentMethod: 'CRD',
            resultErrorMessages: [] as string[],
        };
    },
    methods: {
        async submitPayment() {
            this.resultErrorMessages = [];
            await this.submit();
        },
        async afterSubmit(result: PaymentResult) {
            if (!result.success) {
                this.resultErrorMessages = result.messages;
                const payButton = this.$refs.payButton as HTMLButtonElement;
                payButton.scrollIntoView();
            }
        }
    }
});

export default component;
